import styled from 'styled-components/macro';
import { ADAPTIVE } from '@yme/tokens/screen';
import { INDENT } from '@yme/tokens/sizes';
export const TitleStyled = styled.div `
  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl;'}

  padding: 0 ${INDENT.xs} ${INDENT.sm} ${INDENT.xs};

  ${ADAPTIVE.minWidth.tablet} {
    padding: 0;
    padding-bottom: ${INDENT.sm};
  }

  ${ADAPTIVE.minWidth.desktop} {
    padding: 0;
    padding-bottom: ${INDENT.m};
  }
`;
